const state = {
  customerStatuses: [],
  employeeStatuses: [],
  selectedCustomerStatus: null,
  selectedEmployeeStatus: null,
  selectedLeftBarLink: "",
  statusesCounters: {

  }
};

const mutations = {
  SET_EMPLOYEE_STATUSES(state, paylaod) {
    state.employeeStatuses = paylaod;
  },
  SET_CUSTOMER_STATUSES(state, paylaod) {
    state.customerStatuses = paylaod;
  },
  SET_SELECTED_CUSTOMER_STATUS(state, status) {
    state.selectedCustomerStatus = status
  },
  SET_SELECTED_EMPLOYEE_STATUS(state, status) {
    state.selectedEmployeeStatus = status
  },
  SET_SELECTED_LEFT_BAR_LINK(state, link) {
    state.selectedLeftBarLink = link
  },
  SET_STATUSES_COUNTERS(state, counters) {
    state.statusesCounters = {}
    for (const [key, value] of Object.entries(counters)) {
      state.statusesCounters[key] = value || 0
    }
  }
};

const getters = {
  getEmployeeStatuses: state => state.employeeStatuses,
  getCustomerStatuses: state => state.customerStatuses,
  getSelectedCustomerStatus: state => state.selectedCustomerStatus,
  getSelectedEmployeeStatus: state => state.selectedEmployeeStatus,
  getSelectedLeftBarLink: state => state.selectedLeftBarLink,
  getStatusesCounters: state => state.statusesCounters
};

export default {
  state,
  mutations,
  getters,
};
